<template>
  <div class="rj-col-1">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        收款银行：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item prop="paymentBankId">
          <el-radio-group v-model="form.paymentBankId">
            <el-radio v-for="bank in bankInfos" :key="bank.openBankId" :label="bank.openBankId">
              {{ bank.openBankName }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getBankInfoBySupplyUnitCode } from '@/API';
export default {
  data () {
    return {
      bankInfos: [],
      isFirst: true
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    contractNum: {
      type: [String, Number],
      default: () => { return ''; }
    }
  },
  components: {},
  computed: {},
  methods: {
    searchBank (code) {
      getBankInfoBySupplyUnitCode(code).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          json.data.forEach((item) => {
            if (item.isDefault && !this.form.paymentBankId) {
              this.form.paymentBankId = item.openBankId;
            }
          });

          this.bankInfos = json.data;
          this.isFirst = false;
        }
      }).catch(() => {

      });
    },
    initData () {
      if (this.form.supplyUnitId) {
        this.searchBank({
          'id': this.form.supplyUnitId,
          'contractNum': this.contractNum
        });
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
